import $axios from '@/service/httpServer'


export const getPaymentList = params=>$axios.get(`/pdp/xcx/payment/paymentInfos`, params); //获取付款列表

export const getPaymentStatistics =params=>$axios.get(`pdp/xcx/payment/statistics`, params)  //获取付款概览

export const getPaymentListByid = params=>$axios.get(`/pdp/xcx/payment/logInfo`, params); //根据付款id查询列表

export const getPaymentStatisticsByid =params=>$axios.get(`/pdp/xcx/payment/statisticsInfo`, params)  //根据付款id查询信息